import React from 'react';
import { Box as MaterialBox } from '@mui/material';
import { BoxProps } from './Box.props';

export const Box: React.FC<BoxProps> = ({
  children,
  className
}) => {
  return <MaterialBox className={className}>{children}</MaterialBox>;
};